import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	Output,
	EventEmitter, HostBinding, HostListener, ElementRef, Renderer2
} from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-icon",
	templateUrl: "./icon.component.html"
})
export class IconComponent implements OnInit, OnDestroy {
	@HostBinding("id")
	get circleId() {
		return  this.id;
	}
	@HostBinding("class.fa-xs")
	get iconClassXs() {
		return this.size === "xsmall";
	}

	@HostBinding("class.fa-sm")
	get iconClassSm() {
		return this.size === "small";
	}
	@HostBinding("class.fa-1x")
	get iconClassMd() {
		return this.size === "medium";
	}
	@HostBinding("class.fa-lg")
	get iconClassLg() {
		return this.size === "large";
	}
	@HostBinding("class.fa-2x")
	get iconClass2x() {
		return this.size === "2x";
	}
	@HostBinding("class.fa-3x")
	get iconClass3x() {
		return this.size === "3x";
	}
	@HostBinding("class.fa-5x")
	get iconClass5x() {
		return this.size === "5x";
	}
	@HostBinding("class.fa-7x")
	get iconClass7x() {
		return this.size === "7x";
	}
	@HostBinding("class.fa-10x")
	get iconClass10x() {
		return this.size === "10x";
	}
	@HostBinding("class.rbc-icon-circle")
	get iconClassCircle() {
		return this.circle;
	}
	@HostBinding("class.rbc-icon-circle-border")
	get iconClassCircleBorder() {
		return this.circleBorder && this.circle;
	}

	// Private Members
	block = "rbc-icon";

	// Input Parameters
	@Input() id: string;
	@Input() type: "solid" | "light" | "brand" = "light";
	@Input() icon: string;
	@Input() circle = false;
	@Input() circleBorder = false;
	@Input() showTitle: boolean;
	@Input() label: string;
	@Input() role = "img";
	@Input() wrapperClass: string;
	@Input() tabIndex;
	@Input() ariaHidden;
	@Input() color;
	@Input() stroke;
	@Input() circleColor: string;
	@Input() circleSize: "" | "small" | "large" = "";
	@Input() spin = false;
	@Input() pulse = false;
	@Input() size: "xsmall" | "small" | "medium" | "large" | "2x" | "3x" | "5x" | "7x" | "10x" | "" = "";
	@Input() fixedWidth = false;
	@Input() rotate: ""| 90 | 180 | 270 = "";
	@Input() flip: "" | "horizontal" | "vertical" | "both" = "";

	@HostBinding("class.rbc-icon") iconClass = true;


	constructor(private idService: IdService) {}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	iconType() {
		return (this.type ? "fa" + this.type.substring(0, 1) : "fal");
	}

	validateInputParameters() {
		if (!this.icon) {
			throw new Error("\"icon\" property is required");
		}
	}

	toUppercase(icon) {
		return "fa" + icon.charAt(0).toUpperCase() + icon.slice(1);
	}

	isHidden() {
		return this.ariaHidden;
	}

	calculateIconClasses() {
		const classes = {};
		classes["rbc-icon-img"] = true;
		classes[`${this.iconType()}`] = this.iconType();
		classes[`fa-${this.icon}`] = this.icon;
		classes[`fa-rotate-${this.rotate}`] = this.rotate;
		classes[`fa-flip-${this.flip}`] = this.flip;
		classes[`fa-spin`] = this.spin;
		classes[`fa-pulse`] = this.pulse;
		classes["fa-fw"] = this.fixedWidth;
		return classes;
	}


}
